export default __webpack_public_path__ + "images/0x3333b97138d4b086720b5ae8a7844b1345a33333.png";